import { schema } from "normalizr";
import companySchema from "./company";

const teamSchema = new schema.Entity(
    "teams",
    {
        companyId: companySchema
    },
    { idAttribute: "id" }
);

export default teamSchema;



// WEBPACK FOOTER //
// ./src/schemas/team.js